<template>
  <div class="ticket-view chat-area d-flex flex-column">
    <!-- HEADER PHIẾU -->
    <div class="chat-header d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <div
          class="chat-avatar"
          :class="moduleAvatarClass(activeTicket.moduleType)"
        >
          <i :class="moduleIconClass(activeTicket.moduleType)"></i>
        </div>
        <div class="ml-2">
          <div class="chat-title">
            {{ activeTicket.title }}
          </div>
          <div class="chat-sub text-muted">
            #{{ activeTicket.code }} · {{ moduleLabel(activeTicket.moduleType) }}
          </div>
        </div>
      </div>
      <div class="text-right">
        <div class="small text-muted mb-1">Trạng thái phiếu</div>
        <span class="badge badge-status-lg" :class="statusBadgeClass">
          {{ formatStatus(activeTicket.moduleType, activeTicket.status) }}
        </span>
        <div v-if="isTicketClosed(activeTicket)" class="small text-success mt-1">
          ĐÃ CHỐT · Chat chỉ dùng để tra cứu lịch sử.
        </div>
      </div>
    </div>

    <!-- MAIN CONTENT -->
    <div class="chat-main flex-grow-1">
      <!-- LEFT: CHAT -->
      <div
        class="chat-column"
        :class="{ 'chat-column-wide': infoCollapsed }"
      >
        <!-- Gợi ý nhanh + nút thu/phóng panel phải -->
        <div class="hint-bar small">
          <div class="d-flex align-items-center flex-wrap hint-left">
            <span class="mr-2 text-muted">Gợi ý:</span>

            <template v-if="currentUser.role === 'TAI_XE'">
              <button
                class="btn btn-xs btn-outline-secondary mr-1"
                @click="
                  $emit(
                    'update:draft',
                    'Xe rung mạnh, có tiếng kêu ở bánh trước.'
                  )
                "
              >
                Báo lỗi
              </button>
              <button
                class="btn btn-xs btn-outline-secondary"
                @click="
                  $emit(
                    'update:draft',
                    'Đã sửa xong, em gửi kèm ảnh biên lai ở dưới.'
                  )
                "
              >
                Báo đã sửa xong
              </button>
            </template>

            <template v-else-if="currentUser.role === 'ADMIN'">
              <button
                class="btn btn-xs btn-outline-secondary mr-1"
                @click="
                  $emit(
                    'update:draft',
                    'Anh mang xe ra gara A (địa chỉ ...) rồi gửi ảnh báo giá giúp em.'
                  )
                "
              >
                Hướng dẫn gara
              </button>
              <button
                class="btn btn-xs btn-outline-secondary"
                @click="
                  $emit(
                    'update:draft',
                    'Anh mua phụ tùng tại cửa hàng B, giữ lại hóa đơn giúp em.'
                  )
                "
              >
                Hướng dẫn mua đồ
              </button>
            </template>

            <template v-else>
              <button
                class="btn btn-xs btn-outline-secondary"
                @click="
                  $emit(
                    'update:draft',
                    '@Admin em đã thanh toán phiếu này, vui lòng kiểm tra.'
                  )
                "
              >
                Báo đã thanh toán
              </button>
            </template>
          </div>

          <div class="hint-toggle ml-auto">
            <button
              type="button"
              class="btn btn-sm btn-light toggle-btn"
              @click="toggleInfoPanel"
              :title="infoCollapsed ? 'Mở panel chi tiết' : 'Thu gọn panel'"
            >
              <i
                :class="
                  infoCollapsed ? 'fa fa-chevron-left' : 'fa fa-chevron-right'
                "
              ></i>
            </button>
          </div>
        </div>

        <!-- Danh sách tin nhắn -->
        <div class="chat-messages flex-grow-1" ref="messagesContainer">
          <!-- TIN NHẮN ĐẦU TIÊN: CHI TIẾT PHIẾU BẢO DƯỠNG -->
          <div
            v-if="baoDuongDetail"
            class="message-row system bd-intro"
          >
            <div class="message-bubble bubble-other bd-intro-bubble">
              <div class="bubble-header small">
                <strong><i class="fa fa-wrench mr-1"></i>Thông tin phiếu bảo dưỡng</strong>
              </div>

              <div class="text bd-intro-text">
                <strong>Xe: </strong>{{ baoDuongDetail.xeBienSo }}<br />
                <strong>Loại: </strong>{{ baoDuongDetail.loaiBaoDuong }}<br />
                <strong>Hạng mục: </strong>
                <span>
                  {{ baoDuongDetail.dmHangMucName }}
                </span><br />
                <strong>Mô tả:</strong>
                <span v-if="baoDuongDetail.noiDungCongViec">
                  {{ baoDuongDetail.noiDungCongViec }}
                </span><br />
                <!-- ẢNH SỰ CỐ -->
                <div v-if="baoDuongDetail.anhSuCoUrl" class="bd-image-wrap">
                  <strong v-if="baoDuongDetail.anhSuCoUrl">Ảnh sự cố:</strong>
                  <img
                    :src="baoDuongDetail.anhSuCoUrl"
                    class="bd-image"
                    alt="Ảnh sự cố"
                    @click="openPreview(baoDuongDetail.anhSuCoUrl)"
                  />
                  <div class="bd-image-hint">
                    <i class="fa fa-search-plus mr-1"></i>Nhấn để xem lớn
                  </div>
                </div>
              </div>

              

            </div>
          </div>



          <div
            v-for="m in activeTicket.messages"
            :key="m.id"
            :class="['message-row', messageRowClass(m)]"
          >
            <!-- SYSTEM -->
            <template v-if="m.type === 'SYSTEM'">
              <div class="system-line">
                <span class="system-text">{{ m.text }}</span>
              </div>
            </template>

            <!-- USER -->
            <template v-else>
              <div
                class="avatar-circle small-avatar"
                :class="avatarClassLocal(m.authorRole)"
              >
                <img
                  v-if="isMe(m) && localAvatarUrl"
                  :src="localAvatarUrl"
                  alt="avatar"
                  class="avatar-img"
                />
                <img
                  v-else-if="m.authorAvatarUrl"
                  :src="m.authorAvatarUrl"
                  alt="avatar"
                  class="avatar-img"
                />
                <span v-else>
                  {{ initials(m.authorName || "??") }}
                </span>
              </div>

              <div
                class="message-bubble"
                :class="{
                  'bubble-me': isMe(m),
                  'bubble-other': !isMe(m)
                }"
              >
                <div class="bubble-header">
                  <span class="author">
                    {{
                      isMe(m)
                        ? localUserName || "Tôi"
                        : m.authorName || "Không rõ"
                    }}
                  </span>
                </div>

                <div class="text">
                  {{ m.text }}
                </div>

                <div class="bubble-meta">
                  <span class="time">{{ formatTime(m.createdAt) }}</span>
                </div>
              </div>
            </template>
          </div>

          <div
            v-if="!activeTicket.messages || !activeTicket.messages.length"
            class="small text-muted text-center mt-3"
          >
            Chưa có tin nhắn. Hãy chat như Zalo, trao đổi rõ lỗi & cách xử lý
            với tài xế.
          </div>
        </div>

        <!-- Input giống ô chat Zalo -->
        <div class="chat-input">
          <div class="input-row d-flex align-items-center">
            <button class="btn btn-light btn-sm mr-2">
              <i class="fa fa-smile"></i>
            </button>
            <button class="btn btn-light btn-sm mr-2">
              <i class="fa fa-paperclip"></i>
            </button>
            <textarea
              :value="draft"
              rows="1"
              class="form-control"
              placeholder="Nhập tin nhắn..."
              @input="$emit('update:draft', $event.target.value)"
              @keyup.enter.exact.prevent="$emit('send')"
            ></textarea>
            <button
              class="btn btn-primary ml-2"
              @click="$emit('send')"
              :disabled="!(draft && draft.trim())"
            >
              <i class="fa fa-paper-plane"></i>
            </button>
          </div>
          <div class="input-footer">
            Enter: gửi · Admin có thể chỉ phân công & bấm nút thay vì chat
            nhiều.
          </div>
        </div>
      </div>

      <!-- RIGHT: ACTION / INFO PANEL -->
      <div
        class="info-panel"
        :class="{ 'info-panel-collapsed': infoCollapsed }"
      >
        <transition name="slide-fade">
          <div v-show="!infoCollapsed" class="info-panel-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">
                <i class="fa fa-info-circle mr-1"></i> Thông tin & hành động
              </h6>
            </div>

            <!-- THÔNG TIN PHIẾU -->
            <div class="info-block mb-2">
              <div class="block-title text-muted mb-1">
                Thông tin phiếu
              </div>
              <div class="info-line">
                <strong>Xe:</strong>
                <span class="ml-1">{{ activeTicket.xeBienSo || "N/A" }}</span>
              </div>
              <div class="info-line">
                <strong>Tài xế:</strong>
                <span class="ml-1">{{ activeTicket.tenNguoiTao || "N/A" }}</span>
              </div>
              <div class="info-line">
                <strong>Loại:</strong>
                <span class="ml-1">
                  {{ activeTicket.loaiBaoDuong || "Bảo dưỡng" }}
                </span>
              </div>

              <div class="info-line muted">
                Người phụ trách:
                <template v-if="ownersForActive && ownersForActive.length">
                  <span
                    v-for="(o, idx) in ownersForActive"
                    :key="'o-head-' + idx"
                    class="summary-chip ml-1"
                  >
                    {{ o }}
                  </span>
                </template>
                <span v-else>(Chưa phân công)</span>
              </div>

              <div class="info-line muted">
                Thành viên:
                <template v-if="membersForActive && membersForActive.length">
                  <span
                    v-for="(m, idx) in membersForActive"
                    :key="'m-head-' + idx"
                    class="summary-chip chip-member ml-1"
                  >
                    {{ m }}
                  </span>
                </template>
                <span v-else>(Chưa ai tham gia)</span>
              </div>
            </div>

            <!-- TÓM TẮT CHI PHÍ -->
            <div class="info-block mb-3">
              <div class="block-title text-muted mb-1">
                Chi phí
              </div>
              <div class="d-flex justify-content-between cost-line">
                <div>
                  <strong>Đề xuất:</strong>
                  <span class="text-warning ml-1">
                    {{ formatCurrency(activeTicket.deXuat) }}
                  </span>
                </div>
                <div class="text-right">
                  <strong>Đã duyệt:</strong>
                  <span class="text-success ml-1">
                    {{ formatCurrency(activeTicket.daDuyet) }}
                  </span>
                </div>
              </div>
            </div>

            <!-- PHÂN CÔNG -->
            <div class="info-block mb-3">
              <div class="block-title text-muted mb-1">
                Phân công xử lý
              </div>

              <div class="mb-2">
                <label class="small text-muted d-block mb-1">
                  Thêm thành viên khác
                </label>
                <div class="input-group input-group-sm">
                  <select
                    v-model="selectedUserToAssign"
                    class="form-control"
                  >
                    <option value="">-- Chọn người dùng --</option>
                    <option
                      v-for="u in demoStaff"
                      :key="u.id || u.name || u"
                      :value="u.name || u"
                    >
                      {{ u.name || u }}
                    </option>
                  </select>
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      @click="onClickAddMember"
                    >
                      <i class="fa fa-user-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <!-- ==== FLOW THEO TRẠNG THÁI ==== -->

            <div v-if="activeTicket.status === 'MOI'" class="info-block mt-3">
              <div class="block-title text-muted mb-1">
                Gửi Báo giá từ gara / tài xế
              </div>

              <form @submit.prevent="onSubmitQuotation">
                <div class="form-group mb-2">
                  <label class="small">
                    Tên Gara / Nơi sửa <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model.trim="formGia.garaDeXuat"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="VD: Gara A, địa chỉ..."
                    required
                  />
                </div>

                <div class="form-group mb-2">
                  <label class="small">
                    Chi phí đề xuất (VND) <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model.number="formGia.giaDeXuat"
                    type="number"
                    min="0"
                    class="form-control form-control-sm"
                    placeholder="VD: 450000"
                    required
                  />
                </div>

                <div class="form-group mb-2">
                  <label class="small">Link ảnh báo giá / biên lai (tùy chọn)</label>
                  <input
                    v-model.trim="formGia.anhBaoGiaUrl"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="VD: https://..."
                  />
                </div>

                <button
                  type="submit"
                  class="btn btn-warning btn-block btn-sm"
                >
                  <i class="fa fa-paper-plane mr-1"></i>
                  Gửi Báo giá
                </button>
              </form>
            </div>

            <div
              v-else-if="activeTicket.status === 'CHO_DUYET'"
              class="info-block"
            >
              <div class="block-title text-muted mb-1">
                Bước 2: Duyệt báo giá (Admin)
              </div>
              <p class="small mb-2">
                Gara: <b>{{ activeTicket.garaDeXuat || "-" }}</b><br />
                Đề xuất:
                <b>{{ formatCurrency(activeTicket.deXuat) }}</b>
              </p>
              <button
                class="btn btn-success btn-block btn-sm"
                @click="onApproveCost"
              >
                <i class="fa fa-check mr-1"></i>
                Duyệt báo giá (→ Đã duyệt)
              </button>
            </div>

            <div
              v-else-if="activeTicket.status === 'DA_DUYET'"
              class="info-block"
            >
              <div class="block-title text-muted mb-1">
                Bước 3: Bắt đầu sửa chữa
              </div>
              <p class="small mb-2 text-muted">
                Đã duyệt chi phí:
                <b>{{
                  formatCurrency(
                    activeTicket.daDuyet || activeTicket.deXuat
                  )
                }}</b>
              </p>
              <button
                class="btn btn-primary btn-block btn-sm"
                @click="onStartRepair"
              >
                <i class="fa fa-play-circle mr-1"></i>
                Bắt đầu sửa (→ Đang sửa)
              </button>
            </div>

            <div
              v-else-if="activeTicket.status === 'DANG_SUA'"
              class="info-block"
            >
              <div class="block-title text-muted mb-1">
                Bước 4: Xác nhận hoàn thành sửa
              </div>
              <div class="form-group mb-2">
                <label class="small mb-1">ODO hoàn thành (Km)</label>
                <input
                  v-model.number="formHoanThanh.odoHoanThanh"
                  type="number"
                  min="0"
                  class="form-control form-control-sm"
                  placeholder="VD: 123456"
                />
              </div>
              <div class="form-group mb-2">
                <label class="small mb-1">Chi phí thực tế (VND)</label>
                <input
                  v-model.number="formHoanThanh.chiPhiThucTe"
                  type="number"
                  min="0"
                  class="form-control form-control-sm"
                  placeholder="VD: 1 600 000"
                />
              </div>
              <div class="form-group mb-2">
                <label class="small mb-1">Ảnh biên lai (URL)</label>
                <input
                  v-model.trim="formHoanThanh.bienLaiUrl"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="VD: https://..."
                />
              </div>
              <button
                class="btn btn-info btn-block btn-sm"
                @click="onCompleteRepair"
              >
                <i class="fa fa-flag-checkered mr-1"></i>
                Gửi xác nhận hoàn thành (→ Chờ thanh toán)
              </button>
            </div>

            <div
              v-else-if="activeTicket.status === 'CHO_THANH_TOAN'"
              class="info-block"
            >
              <div class="block-title text-muted mb-1">
                Bước 5: Xác nhận thanh toán (Kế toán / Admin)
              </div>
              <p class="small mb-2 text-muted">
                Chi phí thực tế:
                <b>{{ formatCurrency(activeTicket.chiPhiThucTe) }}</b>
              </p>
              <div class="form-group mb-2">
                <label class="small mb-1">Ghi chú thanh toán (tuỳ chọn)</label>
                <input
                  v-model.trim="formThanhToan.ghiChu"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="VD: Đã chuyển khoản ngày 25/11"
                />
              </div>
              <button
                class="btn btn-success btn-block btn-sm"
                @click="onMarkPaid"
              >
                <i class="fa fa-check mr-1"></i>
                Đánh dấu ĐÃ THANH TOÁN (→ Hoàn thành)
              </button>
            </div>

            <div
              v-else
              class="info-block text-center text-muted"
            >
              <i
                v-if="activeTicket.status === 'HOAN_THANH'"
                class="fa fa-check-circle fa-2x mb-2 text-success"
              ></i>
              <i
                v-else-if="activeTicket.status === 'DA_HUY'"
                class="fa fa-times-circle fa-2x mb-2 text-secondary"
              ></i>
              <p class="small mb-1">
                Phiếu đã
                {{
                  activeTicket.status === "HOAN_THANH" ? "hoàn thành" : "bị hủy"
                }}.
              </p>
            </div>

            <div
              v-if="
                activeTicket.status !== 'HOAN_THANH' &&
                activeTicket.status !== 'DA_HUY'
              "
              class="info-block mt-3"
            >
              <button
                class="btn btn-outline-danger btn-block btn-sm"
                @click="onCancelTicket"
              >
                <i class="fa fa-times mr-1"></i> Hủy phiếu này
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <VueEasyLightbox
      :visible="previewVisible"
      :imgs="previewImgs"
      :index="previewIndex"
      @hide="previewVisible = false"
      />
  </div>


</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";

export default {
  name: "TicketView",
  components: {
    VueEasyLightbox
  },
  props: {
    activeTicket: { type: Object, required: true },
    baoDuongDetail: { type: Object, default: null },

    currentUser: { type: Object, required: true },
    ownersForActive: { type: Array, default: () => [] },
    membersForActive: { type: Array, default: () => [] },
    demoStaff: { type: Array, default: () => [] },
    formDriver: { type: Object, required: true },
    draft: { type: String, default: "" },
    moduleAvatarClass: { type: Function, required: true },
    moduleIconClass: { type: Function, required: true },
    moduleLabel: { type: Function, required: true },
    formatStatus: { type: Function, required: true },
    formatCurrency: { type: Function, required: true },
    initials: { type: Function, required: true },
    formatTime: { type: Function, required: true },
    isTicketClosed: { type: Function, required: true }
  },

  emits: [
    "update:draft",
    "send",
    "add-me-to-members",
    "assign-me-as-owner",
    "assign-person",
    "bd-assign-to-driver",
    "bd-send-quotation",
    "bd-approve-cost",
    "bd-start-repair",
    "bd-complete-repair",
    "bd-mark-paid",
    "cancel-ticket"
  ],

  data() {
    return {
      formGia: {
        garaDeXuat: "",
        giaDeXuat: null,
        anhBaoGiaUrl: ""
      },
      formHoanThanh: {
        odoHoanThanh: null,
        chiPhiThucTe: null,
        bienLaiUrl: ""
      },
      formThanhToan: {
        ghiChu: ""
      },
      infoCollapsed: false,
      selectedUserToAssign: "",
      localUserName: localStorage.getItem("userhoten") || "",
      localAvatarUrl: localStorage.getItem("avatarUrl") || "",

      previewVisible: false,
      previewIndex: 0,
      previewImgs: []
    };
  },

    computed: {
    statusBadgeClass() {
      const st = this.activeTicket.status;
      if (st === "MOI") return "badge-light";
      if (st === "CHO_DUYET") return "badge-warning";
      if (st === "DA_DUYET") return "badge-info";
      if (st === "DANG_SUA") return "badge-primary";
      if (st === "CHO_THANH_TOAN") return "badge-danger";
      if (st === "HOAN_THANH") return "badge-success";
      if (st === "DA_HUY") return "badge-secondary";
      return "badge-light";
    },
    isBaoDuongTicket() {
      return !!(this.activeTicket && this.activeTicket.loaiBaoDuong);
    }
  },

  watch: {
    activeTicket: {
      handler(val) {
        console.log("[TicketView] activeTicket SNAPSHOT:", { ...val });
        console.log(
          "[TicketView] activeTicket RAW:",
          JSON.parse(JSON.stringify(val || {}))
        );
        this.resetFormsFromTicket();
        this.$nextTick(this.scrollToBottom);
      },
      immediate: true
    },
    "activeTicket.messages.length"() {
      this.$nextTick(this.scrollToBottom);
    }
  },


  methods: {
    openPreview(url) {
      if (!url) return;
      this.previewImgs = [url];
      this.previewIndex = 0;
      this.previewVisible = true;
    },

    isMe(m) {
      if (!m) return false;

      const localName = (this.localUserName || "").trim().toLowerCase();
      const msgName = (
        m.authorName ||
        m.createdByName ||
        ""
      )
        .trim()
        .toLowerCase();

      if (localName && msgName && localName === msgName) {
        return true;
      }

      const meId =
        this.currentUser.id ||
        this.currentUser.userId ||
        this.currentUser.accountId;

      const msgId = m.authorId || m.userId || m.createdById;

      if (meId && msgId && String(meId) === String(msgId)) {
        return true;
      }

      return false;
    },

    messageRowClass(m) {
      if (!m) return "";
      if (m.type === "SYSTEM") return "system";
      return this.isMe(m) ? "me" : "other";
    },

    scrollToBottom() {
      const el = this.$refs.messagesContainer;
      if (!el) return;
      el.scrollTop = el.scrollHeight;
    },

    avatarClassLocal(role) {
      switch (role) {
        case "ADMIN":
          return "avatar-admin";
        case "TAI_XE":
          return "avatar-driver";
        case "KE_TOAN":
          return "avatar-accountant";
        default:
          return "avatar-default";
      }
    },

    toggleInfoPanel() {
      this.infoCollapsed = !this.infoCollapsed;
    },

    resetFormsFromTicket() {
      const t = this.activeTicket || {};
      this.formGia.garaDeXuat = t.garaDeXuat || "";
      this.formGia.giaDeXuat = t.deXuat || null;
      this.formGia.anhBaoGiaUrl = t.anhBaoGiaUrl || "";

      this.formHoanThanh.odoHoanThanh = t.odoHoanThanh || null;
      this.formHoanThanh.chiPhiThucTe = t.chiPhiThucTe || null;
      this.formHoanThanh.bienLaiUrl = t.bienLaiUrl || "";

      this.formThanhToan.ghiChu = t.ghiChuThanhToan || "";
    },

    onClickAddMember() {
      const name = (this.selectedUserToAssign || "").trim();
      if (!name) {
        alert("Vui lòng chọn một người dùng để thêm vào nhóm.");
        return;
      }
      this.$emit("assign-person", name);
      this.selectedUserToAssign = "";
    },

    onSubmitQuotation() {
      const { garaDeXuat, giaDeXuat, anhBaoGiaUrl } = this.formGia;

      if (!garaDeXuat || !giaDeXuat || giaDeXuat <= 0) {
        alert("Vui lòng nhập Gara và Giá đề xuất hợp lệ.");
        return;
      }

      this.$emit("bd-send-quotation", {
        garaDeXuat,
        giaDeXuat,
        anhBaoGiaUrl
      });
    },

    onApproveCost() {
      this.$emit("bd-approve-cost");
    },

    onStartRepair() {
      this.$emit("bd-start-repair");
    },

    onCompleteRepair() {
      const { odoHoanThanh, chiPhiThucTe, bienLaiUrl } = this.formHoanThanh;
      if (!odoHoanThanh || !chiPhiThucTe || !bienLaiUrl) {
        alert("Vui lòng nhập đủ ODO, Chi phí thực tế và ảnh biên lai (URL).");
        return;
      }
      this.$emit("bd-complete-repair", {
        odoHoanThanh,
        chiPhiThucTe,
        bienLaiUrl
      });
    },

    onMarkPaid() {
      this.$emit("bd-mark-paid", this.formThanhToan.ghiChu || "");
    },

    onCancelTicket() {
      this.$emit("cancel-ticket");
    }
  },

  mounted() {
    this.$nextTick(this.scrollToBottom);
  }
};
</script>

<style scoped>
.ticket-view {
  height: 100%;
  min-height: 0;
}

.ticket-view.chat-area {
  flex: 1 1 auto;
  min-height: 0;
  background: linear-gradient(135deg, #e5edff, #f9fafb);
}

/* HEADER */
.chat-header {
  padding: 0.7rem 1rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.25);
  background: rgba(255, 255, 255, 0.98);
}
.chat-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.25);
}
.chat-title {
  font-weight: 600;
  font-size: 16px;
  color: #0f172a;
}
.chat-sub {
  font-size: 13px;
  color: #6b7280;
}

/* LAYOUT MAIN */
.chat-main {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  padding: 0.75rem 0.9rem 0.8rem;
  gap: 0.75rem;
}

/* CHAT COLUMN */
.chat-column {
  padding: 0.6rem;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  min-height: 0;
  display: flex;
  flex-direction: column;
  transition: all 0.2s ease;
  backdrop-filter: blur(2px);
  flex: 1 1 auto;
}
.chat-column-wide {
  flex: 1 1 auto;
}

/* RIGHT PANEL */
.info-panel {
  position: relative;
  background: rgba(248, 250, 252, 0.98);
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  flex: 0 0 320px;
  max-width: 320px;
  padding: 0.5rem 0.75rem 0.5rem 0.5rem;
  transition: all 0.2s ease;
}

.info-panel-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
  box-sizing: border-box;
  font-size: 14px;
}

/* scroll */
.info-panel-body::-webkit-scrollbar {
  width: 6px;
}
.info-panel-body::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.8);
  border-radius: 999px;
}
.info-panel-body::-webkit-scrollbar-track {
  background: transparent;
}

/* collapse */
.info-panel-collapsed {
  flex: 0 0 0 !important;
  max-width: 0 !important;
  width: 0 !important;
  padding: 0 !important;
  border: none !important;
  overflow: hidden;
}
.info-panel-collapsed .info-panel-body {
  display: none;
}

/* INFO BLOCKS */
.info-block {
  font-size: 14px;
}
.block-title {
  font-weight: 600;
  font-size: 13px;
}
.info-line {
  font-size: 13px;
  margin-bottom: 2px;
}
.info-line.muted {
  font-size: 13px;
  color: #6b7280;
}

/* GỢI Ý */
.hint-bar {
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.04);
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}
.hint-left .btn {
  border-radius: 999px;
}
.hint-toggle .toggle-btn {
  border-radius: 999px;
  width: 26px;
  height: 26px;
  padding: 0;
}

/* CHAT AREA */
.chat-messages {
  background: radial-gradient(circle at top, #e5edff 0, #dbeafe 40%, #e5e7eb 100%);
  border-radius: 14px;
  padding: 0.75rem 0.75rem 0.6rem;
  border: 1px solid rgba(129, 140, 248, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  flex: 1 1 auto;
  height: 35vh;
}

.message-row {
  display: flex;
  align-items: flex-end;
  margin-bottom: 6px;
}
.message-row.me {
  justify-content: flex-start;
  flex-direction: row-reverse;
}
.message-row.other {
  justify-content: flex-start;
}


/* Bubble */
.message-bubble {
  max-width: 72%;
  padding: 7px 11px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 1.45;
  background: #ffffff;
  color: #111827;
  box-shadow: 0 3px 6px rgba(15, 23, 42, 0.16);
  position: relative;
}
.bubble-header {
  font-size: 13px;
  margin-bottom: 2px;
  color: #4b5563;
}
.bubble-me {
  background: #2563eb;
  color: #f9fafb;
}
.bubble-me .bubble-header {
  color: #e5edff;
}
.bubble-me .bubble-meta {
  color: rgba(226, 232, 240, 0.9);
}
.bubble-other {
  background: rgba(255, 255, 255, 0.96);
  color: #111827;
}
.message-bubble .text {
  white-space: pre-wrap;
  word-break: break-word;
}
.bubble-meta {
  margin-top: 3px;
  font-size: 12px;
  text-align: right;
  color: #6b7280;
}

/* BD detail bubble */
.bd-detail-row {
  justify-content: flex-start;
  margin-bottom: 8px;
}
.bd-detail-bubble {
  max-width: 100%;
  border-style: dashed;
  border-width: 1px;
  border-color: rgba(37, 99, 235, 0.5);
  background: rgba(255, 255, 255, 0.96);
}
.bd-detail-header {
  font-weight: 600;
  font-size: 14px;
  color: #1d4ed8;
  margin-bottom: 4px;
}
.bd-detail-meta {
  font-size: 13px;
  color: #4b5563;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 2px 12px;
  margin-bottom: 4px;
}
.bd-detail-content {
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 6px;
}
.bd-detail-image-wrap {
  margin-top: 4px;
}
.bd-detail-image {
  max-width: 220px;
  max-height: 160px;
  border-radius: 10px;
  object-fit: cover;
  box-shadow: 0 3px 6px rgba(15, 23, 42, 0.22);
}

/* System */
.system-line {
  font-size: 12px;
  color: #6b7280;
}
.system-text {
  background: rgba(15, 23, 42, 0.06);
  padding: 0.1rem 0.6rem;
  border-radius: 999px;
}

/* Avatar */
.avatar-circle.small-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  margin-right: 6px;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(15, 23, 42, 0.25);
}
.message-row.me .avatar-circle.small-avatar {
  margin-right: 0;
  margin-left: 6px;
}
.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.avatar-admin {
  background: linear-gradient(135deg, #6366f1, #a855f7);
}
.avatar-driver {
  background: linear-gradient(135deg, #0ea5e9, #2563eb);
}
.avatar-accountant {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}
.avatar-default {
  background: linear-gradient(135deg, #9ca3af, #6b7280);
}

/* INPUT */
.chat-input {
  margin-top: 0.5rem;
  padding: 0.5rem 0.4rem 0.4rem;
  border-top: 1px solid rgba(148, 163, 184, 0.25);
  background: rgba(255, 255, 255, 0.96);
  border-radius: 14px;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.15);
}
.input-row textarea {
  resize: none;
  min-height: 38px;
  max-height: 80px;
  border-radius: 999px;
  font-size: 14px;
}
.input-row .btn {
  border-radius: 999px;
}
.input-footer {
  font-size: 12px;
  color: #6b7280;
}

/* Badge header */
.badge-status-lg {
  padding: 0.3rem 0.7rem;
  font-size: 12px;
  border-radius: 999px;
}

/* Transition */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.15s ease;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(8px);
}

/* RESPONSIVE */
@media (max-width: 991.98px) {
  .chat-main {
    flex-direction: column;
    padding: 0.6rem 0.6rem 0.7rem;
  }
  .chat-column {
    border-bottom: 1px solid rgba(148, 163, 184, 0.25);
  }
  .info-panel,
  .info-panel-collapsed {
    flex: 0 0 auto !important;
    max-width: 100% !important;
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .chat-header {
    padding: 0.6rem 0.75rem;
  }
  .chat-column {
    padding: 0.4rem;
  }
  .chat-messages {
    padding: 0.5rem;
  }
  .chat-input {
    padding: 0.45rem 0.4rem;
  }
}

.bd-image-wrap {
  margin-top: 6px;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
}

.bd-image {
  max-width: 220px;
  max-height: 60px;
  border-radius: 10px;
  object-fit: cover;
  box-shadow: 0 3px 6px rgba(15, 23, 42, 0.22);
  cursor: zoom-in;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}

.bd-image:hover {
  transform: translateY(-1px) scale(1.01);
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.3);
}

.bd-image-hint {
  font-size: 11px;
  color: #6b7280;
  margin-top: 3px;
}

</style>
